import React from 'react';
import { Paper, Typography } from "@mui/material";
import { MessageProps } from "./TypeMessage";

export const ReceivedMessage = ({ content, timestamp }) => {

    // Formatear el timestamp para mostrar solo la hora
    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    };

    return (
        <div style={{ display: "flex" }}>
            <Paper
                elevation={0}
                style={{
                    backgroundColor: "white",
                    padding: "6px 8px 6px 9px",
                    borderRadius: "7.5px 7.5px 7.5px 0",
                    maxWidth: "78%",
                    boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
                }}
            >
                <Typography variant="body1" style={{ fontSize: "14px", lineHeight: 1.35 }}>{content}</Typography>
                <Typography
                    variant="caption"
                    style={{
                        display: "block",
                        textAlign: "right",
                        marginTop: "4px",
                        fontSize: "11px",
                        color: "#6b7280",
                        lineHeight: 1.2,
                    }}
                >
                    {formatTime(timestamp)}
                </Typography>
            </Paper>
        </div>
    );
}

export default ReceivedMessage;
